import React, { lazy } from 'react'
import ComponentLoader from './component-loader'
import SinglePageCustomMenuLinkLayout from 'screens/public/SinglePageCMLayout'
// import Newsfeeds from 'screens/admin/Newsfeed/newsfeed'

// NEWSFEED
const NewsFeeds = ComponentLoader(
  lazy(() => import('screens/public/Newsfeed/index'))
)

const InstallationPage = ComponentLoader(
  lazy(() => import('screens/public/integration/ghl_installation'))
)

const Iframe = ComponentLoader(lazy(() => import('screens/public/iframe')))

const AppAssociate = ComponentLoader(
  lazy(() => import('screens/public/integration/ghl/app-associate'))
)

const PublicRoutes = [
  {
    path: '/',
    element: <SinglePageCustomMenuLinkLayout />,
    children: [
      {
        path: 'feed/:location_id/:email',
        element: <NewsFeeds />,
      },
    ],
  },
  {
    path: 'integrations',
    children: [
      {
        path: 'crm',
        children: [
          {
            path: 'app',
            element: <AppAssociate />,
          },
        ],
      },
    ],
  },
  {
    path: 'location/:location_id/user/:email',
    element: (
      <div className='p-12'>
        <NewsFeeds />
      </div>
    ),
  },
  {
    path: 'agency/installation',
    element: (
      <div className=''>
        <InstallationPage />
      </div>
    ),
  },
  {
    path: 'agency/iframe',
    element: (
      <div className=''>
        <Iframe />
      </div>
    ),
  },
]

export default PublicRoutes
